(() => {
  const root = document.documentElement;
  const loader = document.querySelector('[data-hamrooq-welcome-loader]');

  if (!loader || !root.classList.contains('hamrooq-loader-pending')) {
    loader?.remove();
    return;
  }

  const startedAt = performance.now();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const minimumDisplay = reduceMotion ? 180 : 1850;
  let dismissed = false;

  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;

    const remaining = Math.max(0, minimumDisplay - (performance.now() - startedAt));
    window.setTimeout(() => {
      loader.classList.add('is-leaving');
      root.classList.remove('hamrooq-loader-pending');
      window.setTimeout(() => loader.remove(), reduceMotion ? 40 : 800);
    }, remaining);
  };

  if (document.readyState === 'complete') dismiss();
  else window.addEventListener('load', dismiss, { once: true });

  window.setTimeout(dismiss, 4000);
})();
